import ProductDescription from './ProductDescription'

const BreakfastCerealProduct = {
  ...ProductDescription,
  category: '05',
  subCategory: '001BC',
  IsBroadband: true,
  Kcals: null,
  Folate: '',
  Fiber: '',
  WholeGrainCert: false,
  Iron: '',
  Sucrose: '',
  Rounding: false,
  UnderIronLimit: false,
  UnderSucroseLimit: false,
  ContainsNoSweeteners: false,
  Size: '',
}

export default BreakfastCerealProduct
